import CircularCardCarousel from "../circular-card-carousel/CircularCardCarousel";

const categoryItems = [
  {
    id: "anti-tarnish",
    label: "Anti-tarnish Jewellery",
    link: "/anti-tarnish-jewellery",
    image:
      "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775486189/IMG_9054_ynvonu.jpg"
  },
  {
    id: "korean-jewellery",
    label: "Korean Jewellery",
    link: "/korean-jewellery",
    image:
      "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360917/5_uphaxx.jpg"
  },
  {
    id: "resin-jewellery",
    label: "Resin Jewellery",
    link: "/resin-jewellery",
    image:
      "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266857/1_dbfz25.jpg"
  },
  {
    id: "tulip-bracelets",
    label: "Tulip Bracelets",
    link: "/tulip-bracelets",
    image:
      "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266910/IMG_9754_ixwp7c.heic"
  },
  {
    id: "enamel-jewellery",
    label: "Enamel Jewellery",
    link: "/enamel-jewellery",
    image:
      "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441567/White_daisy_chain_feo6ug.jpg"
  },
  {
    id: "gift-boxes",
    label: "Gift Boxes",
    link: "/gift-box",
    image:
      "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776445852/1_bncvqp.jpg"
  },
];

export default function WhatAreYouLookingFor() {
  return (
    <CircularCardCarousel
      title="What are you looking for?"
      // subtitle="Swipe to explore product categories"
      items={categoryItems}
      itemsPerSlide={3}
      slideMode="chunk"
      autoplayMs={4000}
    />
  );
}
